export const volumeFederalRegisterItemTypeList = [
  { value: '0' },
  { value: '1' },
  { value: '2' },
]
